/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react'
import { Button, Modal, Input, Checkbox  } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import { getAllAmenities, postHelper } from './helpers'
import { guestroom } from './AmenitiesType'
import './index.scss'

const AddModal = (
  props : {
    visible: boolean,
    loading: boolean,
    setVisible: (a: boolean) => void,
    currentRow: guestroom,
    setDataSource: (a: {}[]) => void,
    getGuestRoomsData?: () => void,
    getGuestRoomsDataForAddition?: (a: number) => void,
  }
) => {
  const { visible, setVisible } = props
  const CheckboxGroup = Checkbox.Group;
  const suffix = (
    <SearchOutlined
      style={{
        fontSize: 16,
        color: '#1890ff',
      }}
    />
  );

  const plainOptions: string[] = [];
  const defaultCheckedList: string[] | any = [];
  
  const [checkedList, setCheckedList] = useState<CheckboxValueType[]>(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true)
  const [selectedAmenities, setSelectedAmenities] = useState<any>(defaultCheckedList)
  const [allAmenities, setAllAmenities] = useState<string | any>([])
  const [cacheAmenities, setcachelAmenities] = useState<string | any>([])
  const [isCheckBoxDisabled, setIsCheckBoxDisabled] = useState(false)
  const [loading, setLoading] = useState(false)

  const onChange = (list: CheckboxValueType[]) => {
    let data
    let hash = {}
    if (allAmenities.length < cacheAmenities.length) {
      // creating the initial hash
      for(let i = 0; i < selectedAmenities.length; i += 1) {
        if (!hash[selectedAmenities[i]]) {
          hash[selectedAmenities[i]] = 1
        } else {
          hash[selectedAmenities[i]] += 1
        }
      }
      // identifiying the unselected ones
      const s = allAmenities.filter((item : any) => !list.includes(item))
      // updating the hash
      for (let j = 0; j < s.length; j += 1) {
        if (hash[s[j]]) {
          delete hash[s[j]]
        }
      }
      // identifiying the selected ones
      const sl = allAmenities.filter((item : any) => list.includes(item))
      // updating the hash
      for (let j = 0; j < sl.length; j += 1) {
        if (!hash[sl[j]]) {
          hash[sl[j]] = 1
        }
      }

      data = Array.from(Object.keys(hash))
      setIsCheckBoxDisabled(true)
    } else {
      data = list
      setIsCheckBoxDisabled(false)
    }

    setIndeterminate(!!list.length && list.length < plainOptions.length);
    // setCheckAll(list.length === plainOptions.length === allAmenities.length < cacheAmenities.length);
    setCheckedList(data);
    setSelectedAmenities(data)
    setIsDisabled(false)
  };

  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    const filteredAmenities = allAmenities.filter((amenity: string) => amenity !== '')
    setCheckedList(e.target.checked ? filteredAmenities : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    setSelectedAmenities(e.target.checked ? filteredAmenities : [])
    setIsDisabled(false)
  };

  const onRemoveAll = (e: boolean = false) => {
    setCheckedList([]);
    setIndeterminate(false);
    setCheckAll(e);
    setSelectedAmenities([])
    setIsDisabled(false)
  };

  const searchAmenities = (query: string) => {
    if (query.length > 0) {
      const filtered = cacheAmenities.filter((amenitie: string) => amenitie.toLowerCase().includes(query))
      setIsCheckBoxDisabled(true)
      return setAllAmenities(filtered)
    }
    setIsCheckBoxDisabled(false)
    return setAllAmenities(cacheAmenities)
  }

  const getAll = useCallback(async () => {
    try {
      if (props.currentRow) {
        const { grid } = props.currentRow
        const data: any = await getAllAmenities(grid)
        data.guestRoomAllAmenities
          .map(({ selected, amenityType } : { selected: boolean, amenityType: string }) => {
            if (selected) {
              defaultCheckedList.push(amenityType)
            }
            return plainOptions.push(amenityType)
          })
          plainOptions.length >= 6 && plainOptions.push('')
        setAllAmenities(plainOptions)
        setcachelAmenities(plainOptions)
      }
    } catch (error) {
      throw error

    }
  },[])

  const postData = useCallback(async (selected: {}[]) => {
    try {
      setLoading(true)
      const { grid, grlangid } = props.currentRow
      let amenities: {}[] = []
      selected
        .forEach((item: number | any) => amenities.push({ 'type': item, categorytype: "Amenity", details: item }))
      const body = {
        guestroom: [
          {
            grid,
            grlangid,
            usedforbulkadd: true,
            amenities
          }
        ]
      }
      const { guestRoomAllAmenities }: {}[] | any = await postHelper('/property/guestroom/amenities', body)

      const dataSource: {}[] = []

      guestRoomAllAmenities?.filter((amenity: { amenityType: string, selected: boolean }) => amenity.selected ? dataSource.push({ type: amenity.amenityType, ...amenity }) : false)

      if (props.getGuestRoomsData) {
        await props.getGuestRoomsData()
      } 

      if (props.getGuestRoomsDataForAddition) {
        await props.getGuestRoomsDataForAddition(grid)
      }

      /* if (!props.getGuestRoomsData || !props.getGuestRoomsDataForAddition) {
        props.setDataSource(dataSource)
      } */

      setLoading(false)
      setVisible(false)
    } catch (error) {
      throw error
    }
  },[])

  useEffect(() => {
    getAll()
  },[])

  return (
    <Modal
      visible={visible}
      title={<b>Add Amenities</b>}
      centered
      width={700}
      footer={[
            <Button
                className={isDisabled ? 'is_disabled': ''}
                key="submit" 
                type="primary" 
                loading={loading} 
                onClick={() => postData(selectedAmenities)}
            >
                Apply
            </Button>,
            <Button 
                key="back" 
                onClick={() => setVisible(false)}
            >
                Cancel
            </Button>,
        ]}
    >
        <section className='amenities_search'>
          <div>
            <Input 
              placeholder="Search amenities here..." 
              size="large"
              suffix={suffix}
              onChange={(e) => searchAmenities(e.target.value)} 
            />
          </div>
          <div>
            <span>{selectedAmenities.length} selected</span>
            <span className='remove_all' onClick={() => onRemoveAll()}>Remove all</span> 
          </div>
        </section>
        <section className='amenities_content'> 
        <div className = 'amenities'>
          <CheckboxGroup
            options={allAmenities} 
            value={checkedList} 
            onChange={(e) => onChange(e)} 
          />
          <Checkbox 
            indeterminate={indeterminate} 
            onChange={onCheckAllChange} 
            checked={checkAll}
            className="check_all_amenities"
            disabled={isCheckBoxDisabled}
          >
            Select all
          </Checkbox>
        </div>
        <div className='selectedAmenities'>
          {
            selectedAmenities.map((checked: string) => (
              <span key={checked}>{ checked }</span>
            ))
          }
        </div>
        </section>
    </Modal>
  )
}

export default AddModal
